import type { EnvironmentMarkerWithNameEnvironment } from '@gonfalon/environments/EnvironmentMarkerWithName';
import type { Environment } from '@gonfalon/environments/types';
import type { Color } from '@gonfalon/legacy-color/colorUtils';

import type { Environment as EnvironmentRep } from '#utils/environments/records/Environment';

export type MarkerEnvironment = EnvironmentRep | Environment;

/**
 * Coerces an environment color into the hex string the marker expects. The color can arrive as a
 * plain string (API type), a legacy `Color` object (Immutable record, or a record run through
 * `.toJS()` which leaves the `Color` in place), or be missing entirely in test fixtures.
 */
function toColorString(color: Color | string | undefined): string {
  if (typeof color === 'string') {
    return color;
  }

  return color?.css?.() ?? '';
}

/**
 * Normalizes either the legacy Immutable `Environment` record or the plain `Environment` type into
 * the plain shape expected by `@gonfalon/environments/EnvironmentMarkerWithName`.
 */
export function toMarkerEnv(env: MarkerEnvironment): EnvironmentMarkerWithNameEnvironment {
  return {
    key: env.key,
    name: env.name,
    color: toColorString(env.color),
    critical: env.critical,
  };
}
